import PropTypes from 'prop-types';
import React from 'react'
import { Link } from 'react-router-dom'
import moment from 'moment'

import timestamps from '~/services/timestamps'


export default class extends React.Component {
    static propTypes = {
		created_date: PropTypes.string,
		resource: PropTypes.object,
		seen: PropTypes.bool
	};

    getLocation = () => {
		var res = this.props.resource;
		if( !!res.camp && res.camp.link ) return <span>in <Link to={res.camp.link} className="low-style">{res.camp.title}</Link></span>
		if( res.interests && res.interests.length ) return <span> {res.interests[0].name}</span>
	};

    render() {

		return (

			<p className="small text-dark-gray">{timestamps.timeSince(this.props.created_date)} {this.getLocation()}</p>

		)
	}
}



// WEBPACK FOOTER //
// ./src/js/components/Notifications/components/Item/components/Footer.js